export default "__VITE_ASSET__mng7djJ3__"